import React from 'react';
import header_bg from '../images/header-bg.jpg'
import logo from '../images/logo.png'
import './Header.css'
import GsdeNav from "./GsdeNav";

export default function Header() {
    return (
        <div className='header'>
                <img className='header-bg' src={header_bg} alt='header-bg'/>
                <img className='logo' src={logo} alt='logo'/>
                <GsdeNav/>
        </div>
    )
}